import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import LastEdition from "./components/Lastedition";
import Footer from "./components/Footer";
import Main from "./components/Jury/main";
import FloatingButton from "./components/FloatingButton";
import JuryAbout from "./components/Jury/about";
import CTA from "./components/Jury/CTA";
import { isMobile } from "react-device-detect";
import { OtherSection } from "./components/otherSection";
import { ImageSection } from "./components/ImageSection";
import NewAgenda from "./components/NewAgenda";
import { ImageSection2 } from "./components/ImageSection2";
import { NewSection } from "./components/NewSection";
import CarouselSection from "./components/CarousalSection";
import MainLayout from "./components/2026Design/MainLayout";
import ContentPart from "./components/ContentPart";
import Agenda2026 from "./components/Agenda2026";
import WorkshopPage from "./components/WorkshopPage";
import QRSection from "./components/QRSection";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {/* <div className="introvideo-container"> */}
        {/* <video
          autoPlay
          muted
          playsInline
          preload="auto"
          className={`background-video ${videoEnded ? "fade-out" : ""}`}
          onLoadedData={() => {
            const isMobile = window.innerWidth <= 768;
            if (!isMobile) {
              document.body.style.overflow = "hidden";
            }
          }}
          onEnded={(e) => {
            console.log("Video ended at:", e.target.currentTime, "seconds");
            setVideoEnded(true);

            setTimeout(() => {
              setHideVideo(true);
              document.body.style.overflowY = "scroll";
            }, 1000); // same duration as CSS transition
          }}
          style={{ display: hideVideo || isMobileScreen ? "none" : "block" }}
        >
          <source src={bgoverlayvideo} type="video/mp4" />
        </video>
        <video
          autoPlay
          muted
          playsInline
          preload="auto"
          className={`background-video ${videoEnded ? "fade-out" : ""}`}
          onLoadedData={() => {
            const isMobile = window.innerWidth <= 768;
            if (!isMobile) {
              document.body.style.overflow = "hidden";
            }
          }}
          onEnded={(e) => {
            console.log("Video ended at:", e.target.currentTime, "seconds");
            setVideoEnded(true);

            setTimeout(() => {
              setHideVideo(true);
              document.body.style.overflowY = "scroll";
            }, 1000); // same duration as CSS transition
          }}
          style={{ display: hideVideo || isMobileScreen ? "none" : "block" }}
        >
          <source src={bgoverlayvideo} type="video/mp4" />
        </video> */}
      {/* </div> */}
      {/* <MainLayout /> */}
      <Navigation />

      <Header data={landingPageData.Header} />
      <ContentPart />
 <QRSection />

      {/* <Contact data={landingPageData.Contact} /> */}


      <LastEdition data={landingPageData.Contact} />
      
      <Agenda2026 />
      <WorkshopPage />
      {/* <CTA /> */}
      <JuryAbout />
     
      <Footer data={landingPageData.Contact} />
      <FloatingButton />
    </div>
  );
};

export default App;
